export default {
  club_name: 'Södertälje SK',
  club_name_short: 'ssk',
  stadium_name: '',
  staging_url: 'https://ssk.api.fangroup.io',
  prod_url: 'https://ssk.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/ssk',
  club_logo: '/assets/teams/ssk.png',
  app_name: 'ssk',
  websale_name: 'ssk',
  ntb_team_id: 10045,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'ssk',
  monolithEnabled: false,
};
